import { Component } from "react";
import Table from 'react-bootstrap/Table';

class CategorizationBoundariesTable extends Component {
    static Title = "Postoperative SSQ-49 question probability mass distributions"
    render() {
        return (
            <Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th>Notional SSQ Score</th>
                    <th>S1Q2 (%)</th>              
                    <th>S1Q13 (%)</th>              
                    <th>S3Q10 (%)</th>              
                    <th>S3Q15 (%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>0</td>
                    <td>1.08</td>
                    <td>8.77</td>
                    <td>2.37</td>
                    <td>7.02</td>
                  </tr>                                
                  <tr>
                    <td>1</td>
                    <td>0.86</td>
                    <td>4.39</td>
                    <td>2.8</td>
                    <td>7.24</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>1.08</td>
                    <td>7.68</td>
                    <td>4.31</td>
                    <td>8.77</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>2.16</td>
                    <td>8.11</td>
                    <td>3.88</td>
                    <td>11.88</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>1.29</td>
                    <td>8.33</td>
                    <td>6.68</td>
                    <td>9.21</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>3.66</td>
                    <td>10.75</td>
                    <td>8.84</td>
                    <td>14.25</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>5.82</td>
                    <td>7.89</td>
                    <td>9.05</td>
                    <td>9.21</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>10.78</td>
                    <td>10.96</td>
                    <td>19.18</td>
                    <td>12.94</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>21.55</td>
                    <td>10.53</td>
                    <td>20.69</td>
                    <td>9.87</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>23.92</td>
                    <td>13.38</td>
                    <td>14.87</td>
                    <td>7.46</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>27.8</td>
                    <td>9.21</td>
                    <td>7.33</td>
                    <td>2.19</td>
                  </tr>
                </tbody>
            </Table>
                    );
    }
}
export default CategorizationBoundariesTable 